export default __webpack_public_path__ + "static/media/GalleryFirstDoodleFullSize.ab50da36.png";